module.exports = __webpack_public_path__ + "static/media/kick-expired.2ee44f2b.svg";